import React from "react";
import { Switch } from "react-router-dom";
import Route from "./Route";
import Home from "../pages/Home";
import Error401 from "../pages/Error401";
import BasicStepper from "../components/BasicStepper";
import Error404 from "../pages/Error404";
import Block from "../pages/Block";
import {RepprovedLink} from "../pages/Block/RepprovedLink";

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Home} isPrivateAndPublic />
    <Route path="/representative/:id" component={Home} />
    <Route path="/card/:idCard" component={Home} />
    <Route path="/indicate/:indicate" component={Home} />
    <Route path="/step/:id" component={BasicStepper} isPrivateAndPublic />
    <Route path="/block" component={Block} isPrivateAndPublic />
    <Route path="/repprovedlink" component={RepprovedLink} isPrivateAndPublic />
    <Route path="/error-401" component={Error401} isPrivateAndPublic />
    <Route path="*" component={Error404} isPrivateAndPublic />
  </Switch>
);

export default Routes;
